import TapaComponent from "./TapaComponent";
import TapaValue from "./TapaValue";

export default class TapaVAV extends TapaComponent {
  //
  constructor(name) {
    super(name, []);

    // Points
    this.addPoint("DamperPos", 0, 100, "%");
    this.addPoint("OccCoolSP", 55, 70, "℉");
    this.addPoint("OccHeatSP", 60, 90, "℉");
    this.addPoint("SpaceTemp", 60, 90, "℉");
    this.addPoint("UnoccCoolSP", 55, 70, "℉");
    this.addPoint("UnoccHeatSP", 60, 90, "℉");
  }

  //Methods
  addPoint(name, lowerBound, upperBound, unit) {
    this._children[name] = new TapaValue(name, lowerBound, upperBound, unit);
  }
}



// WEBPACK FOOTER //
// ./src/lib/TapaVAV.js